import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ActionItem } from '../../../../elements/components/action-item/entities/action-item.entity';
import { IconSize, ShIconModule } from '../../../../elements/components/icon/icon.module';
import { ShFieldLabelComponent } from '../field-label/field-label.component';
import { LabelIcon } from './label-icon.entity';

@Component({
    selector: 'sh-form-label',
    templateUrl: './form-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass, ShActionItemComponent, ShIconModule, ShFieldLabelComponent]
})
export class ShFormLabelComponent {
    public readonly IconSize: typeof IconSize = IconSize;

    public labelIcons = input<LabelIcon[]>([]);

    @Input() for?: string;
    @Input() label?: string;
    @Input() helpText?: string;
    @Input() required?: boolean;
    @Input() actionItems?: ActionItem[];
}
